import { render, staticRenderFns } from "./TwoFactorRegistrationForm.vue?vue&type=template&id=e7100b3c"
import script from "./TwoFactorRegistrationForm.vue?vue&type=script&lang=js"
export * from "./TwoFactorRegistrationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports